import React from "react";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const StoreTitle = ({ title }) => {
  const user = ls.get("user");
  const storeName = user?.storeName || "";

  return (
    <div style={{ marginBottom: "1rem", textAlign: "center" }}>
      {title && (
        <p style={{ margin: 0, fontWeight: "normal", fontSize: "2.25rem" }}>
          {title}
        </p>
      )}
      {storeName && (
        <p style={{ fontSize: "1rem", color: "#666", marginTop: "-0.05rem" }}>
          {storeName}
        </p>
      )}
    </div>
  );
};

export default StoreTitle;
